import { Container, Stack } from "@mui/material";
import MyPersonalData from "../../components/MyPersonalData/MyPersonalData";
import theme from "../../muiTheme";

const MyPersonalDataPage = () => {
  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        paddingY={10}
        bgcolor={theme.palette.grey[50]}
        gap="3rem"
      >
        <MyPersonalData />
      </Stack>
    </Container>
  );
};

export default MyPersonalDataPage;
